import { useQuery } from "@tanstack/react-query";
import { useRecoilValue } from "recoil";
import { Languege } from "../Atom";
import { fetchAservices, fetchFooterData, fetchPromotion, fetchTranslates } from "../Services/Requests";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

const Footer = ({ id }: { id?: string }) => {
  const language = useRecoilValue(Languege);

  const {
    data: Services,
    isLoading: loadingServices,
    error: errorServices,
  } = useQuery({
    queryKey: ["Services", language],
    queryFn: fetchAservices,
  });

  const {
    data: Translates,
    isLoading: loadingTranslates,
    error: errorTranslates,
  } = useQuery({
    queryKey: ["Translates", language],
    queryFn: fetchTranslates,
  });
  const {
    data: Promotion,
    isLoading: loadingPromotion,
    error: errorPromotion,
  } = useQuery({
    queryKey: ["Promotion", language],
    queryFn: fetchPromotion,
  });

  const {
    data: FooterData,
    isLoading: loadingFooterData,
    error: errorFooterData,
  } = useQuery({
    queryKey: ["FooterData", language],
    queryFn: fetchFooterData,
  });
  const location = useLocation();
  const isHome = location.pathname === "/";
  const isContact = location.pathname === "/contact";

  return (
    <footer id={id} className={isHome || isContact ? "home-footer" : ""}>
      <div className="footer-container">
        <div className="footer-sections">
          <div className="main-section">
            <h2 className="short-desc">
              {FooterData?.data.footer_text.description}
            </h2>
            <div className="socials">
              {FooterData?.data.footer_socials.map((item: any) => (
                <a href={item?.url} key={item?.id} className="socialItem">
                  <img
                    src={item?.icon}
                    alt=""
                  />
                </a>
              ))}
            </div>
          </div>
          <div className="footer-section">
            <h2>
              {Translates?.data.data.services}
            </h2>
            <div className="section-links">
              {Services?.data?.map((item: any, index: number) => (
                <HashLink
                  key={index}
                  to={`/services/#${item?.slug}`}
                  scroll={(el) =>
                    el.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    })
                  }
                  className="section-link"
                >
                    {item?.title}
                </HashLink>
              ))}
            </div>
          </div>
          <div className="footer-section">
            <h2>
              {Translates?.data.data.transitions}
            </h2>
            <div className="section-links">
              <Link to="/" className="section-link">
                {Translates?.data.data.home}
              </Link>
              <Link to="/about" className="section-link">
                {Translates?.data.data.about_us}
              </Link>
              <Link to="/news" className="section-link">
                {Translates?.data.data.blog}
              </Link>
              <Link to="/galery" className="section-link">
                {Translates?.data.data.gallery}
              </Link>
              <Link to="/contact" className="section-link">
                {Translates?.data.data.contact}
              </Link>
            </div>
          </div>
          <div className="footer-section">
            <a href={Promotion?.data.file_url} target="_blank">
              <h2>
                {Promotion?.data.title}
              </h2>
            </a>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="copyRight">
            Copyright © {new Date().getFullYear()}{" "}
            <b>Regional Group</b>. Bütün
            hüquqlar qorunur.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
